import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { colombianStates } from '../data/colombia_locations';

export interface State {
  id: number;
  name: string;
  code?: string;
}

@Injectable({
  providedIn: 'root'
})
export class StateService {

  constructor() { }

  /**
   * Obtiene todos los estados/departamentos de Colombia
   * Usa datos estáticos locales para evitar problemas de integración
   */
  getStates(): Observable<State[]> {
    return of(colombianStates);
  }
}
